/* CreateOrgComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./CreateOrgRenderer");

class CreateOrgComponent extends EventEmitter {
    constructor(
        allOrgs,
        selectedOrg,
        userInfo,
        uiUtils,
        logger,
        modalUserFeedback,
        isDCEnabled,
        credentialsList
    ) {
        super();
        this._allOrgs = allOrgs;
        this._userInfo = userInfo;
        this._selectedOrg = selectedOrg;
        this._createModel = {labEnabled: false};
        this._logger = logger;
        this._isDCEnabled = isDCEnabled;
        this._modalUserFeedback = modalUserFeedback;
        this._credentialsList = credentialsList;
        this._renderer = new Renderer(this, uiUtils);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {
        this.removeAllListeners();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get modalUserFeedback() {
        return this._modalUserFeedback;
    }

    get logger() {
        return this._logger;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get allOrgs() {
        return this._allOrgs;
    }

    get selectedOrg() {
        return this._selectedOrg;
    }

    setCredentialsList(credentialsList) {
        this._credentialsList = credentialsList || [];
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer
            ._shutdown()
            .then(() => {
                this._allOrgs = undefined;
                this._createModel = undefined;
                this._renderer = undefined;
                this._modalUserFeedback = undefined;
                this._logger = undefined;
            })
            .catch((err) => {
                console.log("Error shutting down CreateOrgComponent", err);
            });
        return prom;
    }

    changeScreen(displayType) {
        this.emit("SwitchContent", displayType);
    }

    selectedUserInfo() {
        //Someone changed the org, which will take them back to the edit screen.
        this.changeScreen("edit");
    }

    updateCreateModelField(property, value) {
        _.set(this._createModel, property, value);
        this.emit("CreateModelUpdated");
    }

    removeCreateModelField(property) {
        _.unset(this._createModel, property);
        this.emit("CreateModelUpdated");
    }

    createOrg() {
        this.emit("CreateOrg", this._createModel);
    }

    get createModel() {
        return this.getCreateModel();
    }

    getCreateModel() {
        return this._createModel;
    }

    get userInfo() {
        return this.getUserInfo();
    }

    getUserInfo() {
        return this._userInfo;
    }

    setGluAPIEnabled(value) {
        return this.updateCreateModelField("enableApi", Boolean(value));
    }

    getGluAPIEnabled() {
        return this.selectedOrg.enableApi;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    emitTestLdap(data) {
        this.emit("testLDAP", data);
    }

    emitTestRadius(data) {
        this.emit("testRADIUS", data);
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    testLdapError(error) {
        this.emit("TestLdapError", error);
    }

    testRadiusError(error) {
        this.emit("TestRadiusError", error);
    }

    crudError(err) {
        this.emit("CreateOrgError", err.error);
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = CreateOrgComponent;
